document.addEventListener('DOMContentLoaded', function () {

    // ── Header scroll ────────────────────────────────────────
    const header = document.querySelector('header');
    let scrollTop = window.scrollY;
    let lastScrollTop = scrollTop;

    if (scrollTop > 0) header.classList.add('header--scrolled');

    var ticking = false;

    function onScroll() {
        scrollTop = window.scrollY;

        if (header.classList.contains('autoHide')) {
            if (scrollTop < lastScrollTop - 20) {
                header.classList.remove('header--hide');
            } else if (scrollTop > header.offsetHeight) {
                header.classList.add('header--hide');
            }
        }

        scrollTop > 0
            ? header.classList.add('header--scrolled')
            : header.classList.remove('header--scrolled');

        lastScrollTop = scrollTop;
        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            requestAnimationFrame(onScroll);
            ticking = true;
        }
    }, { passive: true });

    // ── Mobile sub-menu ──────────────────────────────────────
    document.querySelectorAll('.menu-header .menu-item-has-children > a').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var sub = this.nextElementSibling;
            if (!sub) return;
            if (sub.style.maxHeight) {
                sub.style.maxHeight = null;
                sub.style.opacity   = '0';
            } else {
                sub.style.maxHeight = sub.scrollHeight + 'px';
                sub.style.opacity   = '1';
            }
        });
    });

    // ── Burger ───────────────────────────────────────────────
    var burger = document.querySelector('.header__burger, .home-header__burger');
    if (burger) {
        burger.addEventListener('click', function () {
            document.body.classList.toggle('menu-open');
        });
    }

    document.querySelectorAll('.menu-item a, .home-header__mobile-link').forEach(function (link) {
        link.addEventListener('click', function () {
            if (burger) burger.classList.remove('active');
            document.body.classList.remove('menu-open');
        });
    });

    // ── Home: плавный скролл по якорям (#form и т.д.) с учётом залипающего хедера ──
    if (document.querySelector('.page-home')) {
        var homeHeader = document.querySelector('.home-header');

        function homeScrollTo(hash) {
            if (!hash || hash === '#') return false;
            var target = document.querySelector(hash);
            if (!target) return false;
            var offset = (homeHeader ? homeHeader.offsetHeight : 0) + 16;
            var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: top, behavior: 'smooth' });
            document.body.classList.remove('menu-open'); // закрыть мобильное меню
            return true;
        }

        document.querySelectorAll('.home-header a[href*="#"], .page-home a[href*="#"]').forEach(function (link) {
            link.addEventListener('click', function (e) {
                var href = link.getAttribute('href') || '';
                var hash = href.charAt(0) === '#' ? href : (href.indexOf('#') !== -1 ? href.slice(href.indexOf('#')) : '');
                if (homeScrollTo(hash)) e.preventDefault();
            });
        });

        // CTA-кнопки (button[data-scroll]) — плавный скролл к секции
        document.querySelectorAll('[data-scroll]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                homeScrollTo(btn.getAttribute('data-scroll'));
            });
        });
    }

    // ── Home trust stats counter (0 → value over 1s on scroll) ─
    var trustVals = document.querySelectorAll('.home-trust__stat-value[data-count]');
    if (trustVals.length && 'IntersectionObserver' in window) {
        var trustObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                trustObserver.unobserve(entry.target);

                var el  = entry.target;
                var raw = el.dataset.count || el.textContent;
                var m   = raw.match(/^([\d.]+)(.*)$/); // числовая часть + хвост (k, %, …)
                if (!m) return;

                var target   = parseFloat(m[1]);
                var tail     = m[2];
                var decimals = (m[1].split('.')[1] || '').length;
                var duration = 1000;
                var startTime = null;

                function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

                function step(ts) {
                    if (!startTime) startTime = ts;
                    var progress = Math.min((ts - startTime) / duration, 1);
                    el.textContent = (target * easeOutCubic(progress)).toFixed(decimals) + tail;
                    if (progress < 1) requestAnimationFrame(step);
                    else el.textContent = m[1] + tail; // точное финальное значение
                }

                requestAnimationFrame(step);
            });
        }, { threshold: 0.5 });

        trustVals.forEach(function (el) { trustObserver.observe(el); });
    }

    // ── Accordion — open first item on load ──────────────────
    document.querySelectorAll('.accordion__list').forEach(function (list) {
        var firstOpen = list.querySelector('.accordion__item--open');
        if (firstOpen) {
            var body = firstOpen.querySelector('.accordion__body');
            body.style.maxHeight = body.scrollHeight + 'px';
            body.style.opacity   = '1';
        }
    });

    // ── Consent text toggle (form) ───────────────────────────
    // Open state is driven purely by the `is-open` class + CSS max-height, so it
    // never depends on scrollHeight (which can read 0 in some layout contexts).
    document.querySelectorAll('.js-consent-toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var wrap = btn.closest('.js-consent-wrap');
            if (!wrap) return;
            var open = wrap.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    });

    // ── Accordion ────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.accordion__trigger');
        if (!trigger) return;

        var item   = trigger.closest('.accordion__item');
        var isOpen = item.classList.contains('accordion__item--open');

        // Read all scrollHeights before any writes (avoid layout thrashing)
        var toClose = Array.from(
            item.closest('.accordion__list').querySelectorAll('.accordion__item--open')
        );
        var closeData = toClose.map(function (openItem) {
            var body = openItem.querySelector('.accordion__body');
            return { item: openItem, body: body, height: body.scrollHeight };
        });

        var openHeight = 0;
        if (!isOpen) {
            var openBody = item.querySelector('.accordion__body');
            item.classList.add('accordion__item--open');
            openHeight = openBody.scrollHeight;
            item.classList.remove('accordion__item--open');
        }

        // Now write
        closeData.forEach(function (d) {
            d.body.style.maxHeight = d.height + 'px';
            d.body.style.opacity   = '1';
            d.item.classList.remove('accordion__item--open');
            d.item.querySelector('.accordion__trigger').setAttribute('aria-expanded', 'false');
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    d.body.style.maxHeight = '0';
                    d.body.style.opacity   = '0';
                });
            });
        });

        if (!isOpen) {
            item.classList.add('accordion__item--open');
            trigger.setAttribute('aria-expanded', 'true');
            var body = item.querySelector('.accordion__body');
            body.style.maxHeight = '0';
            body.style.opacity   = '0';
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    body.style.maxHeight = openHeight + 'px';
                    body.style.opacity   = '1';
                });
            });
        }
    });

    // ── Trainers slider ──────────────────────────────────────
    document.querySelectorAll('.trainers-swiper').forEach(function (el) {
        var wrap = el.closest('.trainers__slider-wrap');
        new Swiper(el, {
            slidesPerView: 3,
            spaceBetween: 24,
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: wrap.querySelector('.trainers__nav--next'),
                prevEl: wrap.querySelector('.trainers__nav--prev'),
            },
            breakpoints: {
                0:    { slidesPerView: 1, spaceBetween: 16, centeredSlides: false },
                600:  { slidesPerView: 2, spaceBetween: 20, centeredSlides: false },
                1024: { slidesPerView: 3, spaceBetween: 24, centeredSlides: true },
            },
        });
    });

    // ── Home trainers slider ─────────────────────────────────
    document.querySelectorAll('.home-trainers__swiper').forEach(function (el) {
        var root = el.closest('.home-trainers__carousel');
        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
                nextEl: root.querySelector('.home-trainers__nav--next'),
                prevEl: root.querySelector('.home-trainers__nav--prev'),
            },
            pagination: {
                el: root.querySelector('.home-trainers__dots'),
                clickable: true,
            },
        });
    });

    // ── Home reviews slider ──────────────────────────────────
    document.querySelectorAll('.home-reviews__swiper').forEach(function (el) {
        var frame = el.closest('.home-reviews__frame');
        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 18,
            navigation: {
                nextEl: frame.querySelector('.home-reviews__nav--next'),
                prevEl: frame.querySelector('.home-reviews__nav--prev'),
            },
            pagination: {
                el: frame.querySelector('.home-reviews__dots'),
                clickable: true,
            },
            breakpoints: {
                576:  { slidesPerView: 2, spaceBetween: 18 },
                834:  { slidesPerView: 3, spaceBetween: 18 },
                1024: { slidesPerView: 4, spaceBetween: 18 },
            },
        });
    });

    // ── Testimonials slider ──────────────────────────────────
    document.querySelectorAll('.testimonials-swiper').forEach(function (el) {
        var right = el.closest('.testimonials__right');
        var pag   = right ? right.querySelector('.testimonials__pagination') : null;
        new Swiper(el, {
            slidesPerView: 3,
            spaceBetween: 20,
            loop: true,
            watchOverflow: false,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            preventClicks: false,
            preventClicksPropagation: false,
            autoplay: { delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true },
            pagination: { el: pag, clickable: true },
            breakpoints: {
                0:    { slidesPerView: 1, spaceBetween: 16 },
                600:  { slidesPerView: 2, spaceBetween: 16 },
                1336: { slidesPerView: 3, spaceBetween: 20 },
            },
            on: {
                init: function () { if (pag) pag.style.display = 'flex'; },
                breakpoint: function () { if (pag) pag.style.display = 'flex'; },
            },
        });

        // Allow clicks on author links without triggering slide change
        el.querySelectorAll('.testimonials__card-author a').forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.stopPropagation();
            });
        });
    });

    // ── Banner parallax ──────────────────────────────────────
    window.addEventListener('load', function () {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
        gsap.registerPlugin(ScrollTrigger);
        if (window.innerWidth < 1024) return; // no parallax on mobile
        var yStart = -25;
        var yEnd   =  25;
        document.querySelectorAll('.acf-block-banner').forEach(function (section) {
            var bg = section.querySelector('.banner__bg');
            if (!bg) return;
            gsap.fromTo(bg,
                { yPercent: yStart },
                { yPercent: yEnd, ease: 'none', scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true, invalidateOnRefresh: true } }
            );
        });
    });

    // ── Goal pill buttons ────────────────────────────────────
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.js-goal-btn');
        if (!btn) return;
        btn.classList.toggle('is-active');
        var scope = btn.closest('form') || document;
        var active = Array.from(scope.querySelectorAll('.js-goal-btn.is-active'))
            .map(function (b) { return b.dataset.value; });
        var goalField = scope.querySelector('input[name="goal"]');
        if (goalField) goalField.value = active.join(', ');
    });

    // ── Scroll to form ───────────────────────────────────────
    // Все CTA (.js-to-form) ведут на НИЖНЮЮ форму, независимо от того,
    // какой якорь задан в ACF (#form / #contact-form и т.п.).
    var formSections = document.querySelectorAll('.acf-block-form');
    var lastForm = formSections[formSections.length - 1] || null;
    document.querySelectorAll('.js-to-form').forEach(function (btn) {
        // Нормализуем href, чтобы якорь совпадал с реальным id нижней формы
        if (lastForm && lastForm.id && btn.tagName === 'A') {
            btn.setAttribute('href', '#' + lastForm.id);
        }
        btn.addEventListener('click', function (e) {
            if (!lastForm) return;
            e.preventDefault();
            var top = lastForm.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({ top: top, behavior: 'smooth' });
        });
    });

    // ── Price page ───────────────────────────────────────────
    if (document.querySelector('.page-price')) {
        function toEmbedUrl(url) {
            var u = url.trim();
            if (/youtu\.be\//.test(u)) {
                u = u.replace(/.*youtu\.be\/([^?]+).*/, 'https://www.youtube.com/embed/$1');
            } else if (/youtube\.com\/watch/.test(u)) {
                var id = u.match(/[?&]v=([^&]+)/);
                u = id ? 'https://www.youtube.com/embed/' + id[1] : u;
            } else if (/vimeo\.com\/(\d+)/.test(u)) {
                var vid = u.match(/vimeo\.com\/(\d+)/);
                u = vid ? 'https://player.vimeo.com/video/' + vid[1] : u;
            }
            return u + (u.includes('?') ? '&' : '?') + 'autoplay=1&rel=0';
        }

        document.querySelectorAll('.js-price-play').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var screen = btn.closest('.js-price-screen');
                var iframe = screen ? screen.querySelector('.js-price-iframe') : null;
                if (!iframe) return;
                iframe.src = toEmbedUrl(btn.dataset.video);
                screen.classList.add('is-playing');
            });
        });
    }

    // ── Contact forms AJAX ───────────────────────────────────
    function formatPhone(val) {
        var digits = val.replace(/\D/g, '');
        if (digits.length > 0 && digits[0] === '1') digits = digits.slice(1);
        digits = digits.slice(0, 10);
        if (!digits) return '';
        var r = '+1 (' + digits.slice(0, 3);
        if (digits.length > 3) r += ') ' + digits.slice(3, 6);
        if (digits.length > 6) r += '-' + digits.slice(6, 10);
        return r;
    }

    document.querySelectorAll('.js-contact-form').forEach(function (form) {
        var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var phoneRe = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;

        form.querySelectorAll('[type=email]').forEach(function (el) {
            el.addEventListener('input', function () {
                el.classList.remove('input--error');
                var msg = form.querySelector('.js-form-msg');
                if (msg) { msg.classList.remove('success', 'error'); msg.textContent = ''; }
            });
        });

        form.querySelectorAll('[type=tel]').forEach(function (el) {
            el.addEventListener('input', function () {
                var pos = el.selectionStart;
                var oldLen = el.value.length;
                el.value = formatPhone(el.value);
                var newLen = el.value.length;
                el.setSelectionRange(pos + (newLen - oldLen), pos + (newLen - oldLen));
                el.classList.remove('input--error');
                var msg = form.querySelector('.js-form-msg');
                if (msg) { msg.classList.remove('success', 'error'); msg.textContent = ''; }
            });
        });

        form.addEventListener('submit', function (e) {
            e.preventDefault();

            var btn        = form.querySelector('button[type="submit"]');
            var msg        = form.querySelector('.js-form-msg');
            var emailInput = form.querySelector('[type=email]');
            var phoneInput = form.querySelector('[type=tel]');
            var valid      = true;

            [emailInput, phoneInput].forEach(function (el) { if (el) el.classList.remove('input--error'); });
            if (msg) { msg.classList.remove('success', 'error'); msg.textContent = ''; }

            if (emailInput && !emailRe.test(emailInput.value.trim())) {
                emailInput.classList.add('input--error'); valid = false;
            }
            if (phoneInput && phoneInput.value.trim() && !phoneRe.test(phoneInput.value.trim())) {
                phoneInput.classList.add('input--error'); valid = false;
            }
            if (!valid) {
                if (msg) { msg.classList.add('error'); msg.textContent = 'Please enter a valid email and phone number.'; }
                return;
            }

            var params = new URLSearchParams(new FormData(form));
            params.set('action', 'contact_form_submit');
            params.set('contact_nonce', (window.appVars && window.appVars.nonce) || '');
            params.set('page_url', window.location.href);

            btn.disabled    = true;
            btn.textContent = 'Sending...';

            fetch((window.appVars && window.appVars.ajaxurl) || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            })
            .then(function (r) { return r.json(); })
            .then(function (res) {
                if (!msg) return;
                if (res.success) {
                    window.location.href = '/thank-you/';
                } else {
                    msg.classList.add('error');
                    msg.textContent = res.data.message;
                }
            })
            .catch(function () {
                if (msg) { msg.classList.add('error'); msg.textContent = 'Something went wrong. Please try again.'; }
            })
            .finally(function () {
                btn.disabled    = false;
                btn.textContent = btn.dataset.label || 'SUBMIT';
            });
        });
    });

});
